import $ from 'jquery';
import Registration from './components/registration';
import DateInput from '../../components/date-input';
import Timer from '../../components/timer';
import StickyBar from '../../components/sticky-bar';
import RegistrationChangeEmail from './components/registration-change-email';
//onunload function for firefox to run script on going back
window.onunload = () => { };
$(document).ready(() => {
    Registration.init();
    RegistrationChangeEmail.init();
    DateInput.init();
    Timer.init();
    StickyBar.init();
});
